import { render, staticRenderFns } from "./UserAclDeleteModal.vue?vue&type=template&id=61a2bb79&"
import script from "./UserAclDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./UserAclDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports